import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./MemberRegistration.module.css";
import rstyles from "./RegistrationDataShow.module.css";
import ChilldrenInfo from "./ChilldrenInfo";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import isValidPassword from "../utils/passwordValidator";
import { HiEye, HiEyeOff } from "react-icons/hi";
const MemberRegistration = () => {
  const navigate = useNavigate();
  // const [childCounter, setChildCounter] = useState([0]); //manage chlidren info form
  const token = localStorage.getItem("registration_token");
  if (!token) {
    // navigate("/register");
    console.log("Token not found");
    alert("you have to try again. Token not found.");
  }
  const savedPrevious = localStorage.getItem("form_details") !== null;
  let verified_email = "";
  let verified_phonenumber = "";

  if (localStorage.getItem("verified_email")) {
    verified_email = localStorage.getItem("verified_email");
  } else if (localStorage.getItem("verified_phone")) {
    verified_phonenumber = localStorage.getItem("verified_phone");
    console.log(verified_phonenumber, "from 26 no line");
  }

  let firstname = "";
  if (localStorage.getItem("firstname")) {
    firstname = localStorage.getItem("firstname");
  }

  let lastname = "";
  if (localStorage.getItem("lastname")) {
    lastname = localStorage.getItem("lastname");
  }

  let savedUserInfo = {};
  let savedUserQA = {};
  let savedChildInfo = {};
  let savedUserCode = false;
  if (savedPrevious) {
    const {
      userInfo: temp1,
      userQa: temp2,
      childInfo: temp3,
      userCode: temp4,
    } = JSON.parse(localStorage.getItem("form_details"));
    savedUserInfo = temp1;
    savedUserQA = temp2;
    savedChildInfo = temp3;
    savedUserCode = temp4;
    if (verified_email) {
      savedUserInfo.emailaddress = verified_email;
    } else if (verified_phonenumber) {
      savedUserInfo.phone = verified_phonenumber;
    }
  }
  const initialChildInfo = savedPrevious
    ? savedChildInfo
    : [
        {
          name: "",
          furigana: "",
          gender: "",
          year: "",
          month: "",
          day: "",
        },
      ];

  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [done, setDone] = useState(false); // manage blank field color and text
  const [receive, setReceived] = useState(false); //manage all data

  const [children, setChildren] = useState([...initialChildInfo]);

  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const initialUserInfo = savedPrevious
    ? savedUserInfo
    : {
        firstname: firstname,
        lastname: lastname,
        furigana_firstname: "",
        furigana_lastname: "",
        phone: verified_phonenumber,
        postcode: "",
        prefectures: "",
        municipalities: "",
        buildingName: "",
        emailaddress: verified_email,
        password: "",
        confarmpassword: "",
      };
  const [userInfo, setuserInfo] = useState(initialUserInfo);

  const initialQAInfo = savedPrevious
    ? savedUserQA
    : {
        photoPermission: "",
        namePermission: "",
        ホームページ: false,
        Instagramの投稿: false,
        SNSの広告: false,
        お知り合いからのご紹介: false,
        その他: false,
      };

  const [questionnaire, setQuestionnaire] = useState(initialQAInfo);
  //This method is used to create another children info form
  const anotherChildForm = () => {
    setChildren([...children, initialChildInfo]);
  };
  //This function is passed to the ChildrenInfo component
  const addChildinfo = (index, info) => {
    let temp = children;
    temp[index] = info;
    setChildren(temp);
  };
  //on change method for user info
  const userOnChange = (e) => {
    setuserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };
  //on change method for question
  const questionOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    if (name !== "photoPermission" && name !== "namePermission") {
      setQuestionnaire({ ...questionnaire, [e.target.name]: value });
    } else {
      setQuestionnaire({ ...questionnaire, [e.target.name]: e.target.value });
    }
  };

  const submit = () => {
    if (!isValidPassword(userInfo.password)) {
      alert(
        "パスワードには、少なくとも 1 つの大文字と 1 つの小文字を含む 8 文字を含める必要があります。"
      );
      return;
    }
    setDone(true);
    if (
      acceptedPrivacy &&
      userInfo.firstname &&
      userInfo.lastname &&
      userInfo.furigana_firstname &&
      userInfo.furigana_lastname &&
      userInfo.phone &&
      userInfo.postcode &&
      userInfo.prefectures &&
      userInfo.municipalities &&
      userInfo.emailaddress &&
      userInfo.password &&
      userInfo.confarmpassword &&
      questionnaire.photoPermission &&
      questionnaire.namePermission &&
      (questionnaire.Instagramの投稿 ||
        questionnaire.SNSの広告 ||
        questionnaire.お知り合いからのご紹介 ||
        questionnaire.その他 ||
        questionnaire.ホームページ)
    ) {
      setReceived(true);
      axios
        .post(backend_base + "/user/register", {
          user_info: userInfo,
          question_info: questionnaire,
          children_info: children,
          token: token,
        })
        .then((response) => {
          if (response.status === 201) {
            //goto next page
            console.log("CREATED");
            console.log(response.data);
            localStorage.setItem(
              "form_details",
              JSON.stringify({
                userInfo: userInfo,
                userQa: questionnaire,
                childInfo: children,
                userCode: response.data.user_code,
              })
            );
            // Delete the "registration_token" field from local storage
            localStorage.removeItem("registration_token");
            navigate("/registration-data");
          } else {
            console.log("INFORMATION COULD NOT BE SAVED");
          }
        })
        .catch((error) => {
          console.log(error);

          console.log("INFORMATION COULD NOT BE SAVED");
        });
    } else {
      alert("Fill Up All Field");
    }
  };
  const fetchAddress = (value) => {
    let zipsearch = value;
    if (value.length > 7) {
      zipsearch = value.replace(/[- ]/g, "");
    }
    zipsearch = parseInt(zipsearch);
    axios
      .post(backend_base + "/user/get/jp/address", {
        zipcode: zipsearch,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          const data = response.data.address_data.results[0];
          console.log(data);
          setuserInfo({
            ...userInfo,
            prefectures: data["address1"],
            municipalities: data["address2"] + " " + data["address3"],
            postcode: value,
          });
          console.log(data["address1"]);
          console.log(data["address2"]);
          console.log(data["address3"]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Header />
      <div className={`${styles.member}`}>
        <div className={` ${styles.member_content}`}>
          <h6>MEMBERSHIP</h6>
          <h6>新規会員登録</h6>
          <div className={`${styles.input}`}>
            <div className={`${styles.input_main_data}`}>
              <div className="d-flex">
                <h6 className={styles.label}>会員ID</h6>
                <div className={styles.blankField}></div>
                <div>
                  <h6 className={styles.comment}>会員IDは店舗発行致します。</h6>
                </div>
              </div>
              {/* first name and last name */}
              <div className="d-flex mt-3">
                <h6 className={styles.label}>お名前</h6>
                <div>
                  {done && userInfo.firstname === "" ? (
                    <input
                      className={`${styles.firstinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="firstname"
                      onChange={userOnChange}
                      value={userInfo.firstname}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.firstinput}
                      type="text"
                      placeholder="姓"
                      name="firstname"
                      value={userInfo.firstname}
                    />
                  )}
                </div>
                <div>
                  {done && userInfo.lastname === "" ? (
                    <input
                      className={`${styles.secondinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="lastname"
                      onChange={userOnChange}
                      value={userInfo.lastname}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.secondinput}
                      type="text"
                      placeholder="名"
                      name="lastname"
                      value={userInfo.lastname}
                    />
                  )}
                </div>
              </div>
              {/* furigana first name and last name */}
              <div className={`d-flex mt-3 ${styles.three}`}>
                <h6 className={styles.label}>ふりがな</h6>
                <div>
                  {done && userInfo.furigana_firstname === "" ? (
                    <input
                      className={`${styles.firstinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="furigana_firstname"
                      onChange={userOnChange}
                      value={userInfo.furigana_firstname}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.firstinput}
                      type="text"
                      placeholder="せい"
                      name="furigana_firstname"
                      value={userInfo.furigana_firstname}
                    />
                  )}
                </div>
                <div>
                  {done && userInfo.furigana_lastname === "" ? (
                    <input
                      className={`${styles.secondinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="furigana_lastname"
                      onChange={userOnChange}
                      value={userInfo.furigana_lastname}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.secondinput}
                      type="text"
                      placeholder="めい"
                      name="furigana_lastname"
                      value={userInfo.furigana_lastname}
                    />
                  )}
                </div>
              </div>
              {/* phone */}
              <div className={`d-flex mt-3 ${styles.four}`}>
                <h6 className={styles.label}>携帯電話</h6>
                <div>
                  {done && userInfo.phone === "" ? (
                    <input
                      className={`${styles.firstinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="phone"
                      onChange={userOnChange}
                      value={userInfo.phone}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.firstinput}
                      type="text"
                      placeholder="半角数字ハイフン不要"
                      name="phone"
                      value={userInfo.phone}
                    />
                  )}
                </div>
              </div>
              {/* post code */}
              <div className={`d-flex mt-3 ${styles.five}`}>
                <h6 className={styles.label}>郵便番号</h6>
                <div>
                  {done && userInfo.postcode === "" ? (
                    <input
                      className={`${styles.firstinput} ${styles.redPlace}`}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="postcode"
                      onChange={(e) => {
                        userOnChange(e);
                        if (!parseInt(e.target.value)) return;
                        if (e.target.value.length >= 7) {
                          fetchAddress(e.target.value);
                        }
                      }}
                      value={userInfo.postcode}
                    />
                  ) : (
                    <input
                      onChange={(e) => {
                        userOnChange(e);
                        if (!parseInt(e.target.value)) return;
                        if (e.target.value.length >= 7) {
                          fetchAddress(e.target.value);
                        }
                      }}
                      className={styles.firstinput}
                      type="text"
                      placeholder="半角数字ハイフン不要"
                      name="postcode"
                      value={userInfo.postcode}
                    />
                  )}
                </div>
                <div>
                  <h6
                    onClick={() => {
                      if (!parseInt(userInfo.postcode)) return;
                      if (userInfo.postcode >= 7) {
                        fetchAddress(userInfo.postcode);
                      }
                    }}
                    className={styles.link}
                  >
                    郵便番号検索
                  </h6>
                </div>
              </div>
              {/* prefectures */}
              <div className={`d-flex mt-3 ${styles.six}`}>
                <h6 className={styles.label}>都道府県</h6>
                <div>
                  {done && userInfo.prefectures === "" ? (
                    <input
                      className={`${styles.firstinput} ${styles.redPlace}`}
                      onChange={userOnChange}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="prefectures"
                      value={userInfo.prefectures}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.firstinput}
                      type="text"
                      placeholder=""
                      name="prefectures"
                      value={userInfo.prefectures}
                    />
                  )}
                </div>
              </div>
              {/* municipalities */}
              <div className={`d-flex mt-3 ${styles.seven}`}>
                <h6 className={styles.label}>市区町村以下</h6>
                <div>
                  {done && userInfo.municipalities === "" ? (
                    <input
                      className={`${styles.singleinput} ${styles.redPlace}`}
                      onChange={userOnChange}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="municipalities"
                      value={userInfo.municipalities}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.singleinput}
                      type="text"
                      placeholder=""
                      name="municipalities"
                      value={userInfo.municipalities}
                    />
                  )}
                </div>
              </div>
              {/* building name  */}
              <div className={`d-flex mt-3 ${styles.eight}`}>
                <h6 className={styles.label}>建物名</h6>
                <div>
                  {done && userInfo.buildingName === "" ? (
                    <input
                      className={`${styles.singleinput} ${styles.redPlace}`}
                      onChange={userOnChange}
                      type="text"
                      placeholder="※必須入力項目です"
                      name="buildingName"
                      value={userInfo.buildingName}
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.singleinput}
                      type="text"
                      placeholder=""
                      name="buildingName"
                      value={userInfo.buildingName}
                    />
                  )}
                </div>
              </div>
              {/* email address */}
              <div className={`d-flex mt-3 ${styles.nine}`}>
                <h6 className={styles.label}>メールアドレス</h6>
                <div>
                  {done && userInfo.emailaddress === "" ? (
                    <input
                      className={`${styles.singleinput} ${styles.redPlace}`}
                      type="email"
                      placeholder="※必須入力項目です"
                      name="emailaddress"
                      onChange={userOnChange}
                      value={userInfo.emailaddress}
                      autoComplete="off"
                    />
                  ) : (
                    <input
                      onChange={userOnChange}
                      className={styles.singleinput}
                      type="email"
                      placeholder=""
                      name="emailaddress"
                      value={userInfo.emailaddress}
                      autoComplete="off"
                    />
                  )}
                </div>
              </div>
              {/* password */}
              <div className={`d-flex mt-3 ${styles.ten}`}>
                <h6 className={styles.label}>パスワード</h6>
                <div>
                  {done && userInfo.password === "" ? (
                    <PasswordInput
                      name="password"
                      placeholderTxt={"※必須入力項目です"}
                      value={userInfo.password}
                      handlePasswordChange={userOnChange}
                    />
                  ) : (
                    <div className="d-flex" style={{ gap: "10px" }}>
                      <PasswordInput
                        name="password"
                        placeholderTxt={"Sample1234"}
                        value={userInfo.password}
                        handlePasswordChange={userOnChange}
                      />
                      <span className={styles.show_info}>
                        英文字小文字と数字を合わせて <br />
                        ８文字以上で設定して下さい。
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className={`d-flex mt-3 ${styles.eleven}`}>
                <h6 className={styles.label}>確認用パスワード</h6>
                <div>
                  {done && userInfo.confarmpassword === "" ? (
                    <PasswordInput
                      name="confarmpassword"
                      placeholderTxt={"※必須入力項目です"}
                      value={userInfo.confarmpassword}
                      handlePasswordChange={userOnChange}
                    />
                  ) : (
                    <PasswordInput
                      name="confarmpassword"
                      placeholderTxt={""}
                      value={userInfo.confarmpassword}
                      handlePasswordChange={userOnChange}
                    />
                  )}
                </div>
              </div>
              {Array.isArray(children) &&
                children.length > 0 &&
                children.map((data, i) => (
                  <ChilldrenInfo
                    key={i}
                    addChildinfo={addChildinfo}
                    done={done}
                    index={i}
                    initialData={data}
                  />
                ))}

              <div onClick={anotherChildForm} className={`${styles.addChild}`}>
                <h6>+追加のお子様情報</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.lastsection}`}>
        <h6 className={styles.lastsectionHeading}>ご来店アンケート</h6>
        <hr className={styles.hr} />
        <h6 className={styles.question}>
          1. 撮影したお写真をHPやSNSなどに掲載してもよろしいですか?
        </h6>
        <div className={`d-flex ${styles.answer}`}>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={styles.radioInput}
              type="radio"
              name="photoPermission"
              value="家族全員OK"
              checked={questionnaire.photoPermission === "家族全員OK"}
            />
            <h6 className={styles.radiovalue}>家族全員OK</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={styles.radioInput}
              type="radio"
              name="photoPermission"
              value="こどものみOK"
              checked={questionnaire.photoPermission === "こどものみOK"}
            />
            <h6 className={styles.radiovalue}>こどものみOK</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={styles.radioInput}
              type="radio"
              name="photoPermission"
              value="掲載NG"
              checked={questionnaire.photoPermission === "掲載NG"}
            />
            <h6 className={styles.radiovalue}>掲載NG</h6>
          </div>
        </div>
        <h6 className={styles.question}>
          2.【OKの場合】 お名前の掲載はしてもよろしいですか?
        </h6>
        <div className={`d-flex ${styles.answer}`}>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={styles.radioInput}
              type="radio"
              name="namePermission"
              value="名前掲載OK"
              checked={questionnaire.namePermission === "名前掲載OK"}
            />
            <h6 className={styles.radiovalue}>名前掲載OK</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={styles.radioInput}
              type="radio"
              name="namePermission"
              value="名前掲載NG"
              checked={questionnaire.namePermission === "名前掲載NG"}
            />
            <h6 className={styles.radiovalue}>名前掲載NG</h6>
          </div>
        </div>
        <h6 className={styles.question}>
          3. Acestudioを何でお知りになられましたか?(複数選択可)
        </h6>
        <div className={`d-flex ${styles.answer}`}>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={rstyles.checkbox}
              type="checkbox"
              name="ホームページ"
              value={true}
              checked={questionnaire.ホームページ}
            />
            <h6 className={styles.radiovalue}>ホームページ</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={rstyles.checkbox}
              type="checkbox"
              name="Instagramの投稿"
              value={true}
              checked={questionnaire.Instagramの投稿}
            />
            <h6 className={styles.radiovalue}>Instagramの投稿</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={rstyles.checkbox}
              type="checkbox"
              name="SNSの広告"
              value={true}
              checked={questionnaire.SNSの広告}
            />
            <h6 className={styles.radiovalue}>SNSの広告</h6>
          </div>
        </div>
        <div className={`d-flex ${styles.answer}`}>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={rstyles.checkbox}
              type="checkbox"
              name="お知り合いからのご紹介"
              value={true}
              checked={questionnaire.お知り合いからのご紹介}
            />
            <h6 className={styles.radiovalue}>お知り合いからのご紹介</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={questionOnChange}
              className={rstyles.checkbox}
              type="checkbox"
              name="その他"
              value={true}
              checked={questionnaire.その他}
            />
            <h6 className={styles.radiovalue}>その他</h6>
          </div>
        </div>
      </div>
      <div className={styles.bottom1_main}>
        <div className={styles.bottom1_main_header}>
          My Ace個人情報取り扱いに同意します。
        </div>
        <div className={styles.bottom1_subtext}>個人情報の取り扱いについて</div>
        <div className={styles.bottom1_check_main}>
          <input
            className={styles.bottom1_check}
            type="checkbox"
            name="privacy_accept"
            onClick={(e) => {
              setAcceptedPrivacy(!acceptedPrivacy);
            }}
          ></input>
          <div className={styles.bottom1_check_text}>
            上記内容を確認しチェックを入れてください。
          </div>
        </div>
      </div>
      <div className={`${styles.button}`}>
        <div className={styles.bottom2_button_main}>
          <button
            onClick={() => {
              if (savedUserCode) {
                navigate("/registration-data");
              } else {
                navigate("/otp");
              }
            }}
          >
            戻る
          </button>
          <button
            className={styles.bottom2_button2}
            onClick={() => {
              if (savedUserCode) {
                navigate("/registration-data");
              } else {
                submit();
              }
            }}
          >
            次へ
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

const PasswordInput = ({
  name,
  value,
  placeholderTxt,
  handlePasswordChange,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className={`d-flex align-items-center pr-2 ${styles.singleinput2}`}>
      <input
        style={{
          border: "none",
          outline: "none",
          margin: 0,
          padding: 0,
          paddingLeft: "13px",
          marginLeft: "7px",
        }}
        name={name}
        type={isPasswordVisible ? "text" : "password"}
        value={value}
        onChange={handlePasswordChange}
        placeholder={`${placeholderTxt}`}
        autoComplete="new-password"
      />
      <span style={{ cursor: "pointer" }} onClick={togglePasswordVisibility}>
        {isPasswordVisible ? <HiEye color="#bbb" /> : <HiEyeOff color="#bbb" />}
      </span>
    </div>
  );
};

export default MemberRegistration;
